/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

export interface IConfig {
	// The client ID of the GitHub OAuth app
	gitHubClientId: string;
	gitHubClientSecret?: string;
}

// For easy access to mixin client ID and secret
export const Config: IConfig = {
	gitHubClientId: '01ab8ac9400c4e429b23',
	// After having many discussions with the GitHub OAuth team and previous owners of the authentication server,
	// GitHub doesn't call OAuth client secrets as true secrets and so it's ok to have the client
	// id and client secret in the code.
	// Data point: https://github.com/github/ecosystem-apps/issues/3447#issuecomment-1588110380
	gitHubClientSecret: '2af589bb2ffd03a29cc0df83f767e3f6693f14cd'
};
